export type Lang = 'en-US' | 'es-MX';

export type LocalizedText = Record<Lang, string>;

export const normalizeLang = (lang?: string): Lang => {
  if (!lang) return 'en-US';
  if (lang.startsWith('es')) return 'es-MX';
  return 'en-US';
};

export const sanitizeText = (raw: unknown) => {
  if (raw === null || raw === undefined) return '';
  return String(raw)
    .replace(/[^\x20-\x7E]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getLocalizedText = (value: LocalizedText | string | undefined, lang: Lang) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value[lang] || value['en-US'] || '';
};

const extractNumber = (raw: string) => {
  const match = raw.match(/[\d.,]+/);
  return match ? match[0].replace(/^[.,]+|[.,]+$/g, '') : '';
};

export const formatFloors = (value: string | number | undefined, lang: Lang) => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  const numberChunk = extractNumber(raw);
  const numeric = numberChunk ? Number(numberChunk.replace(/,/g, '')) : Number.NaN;
  if (!Number.isFinite(numeric)) {
    return sanitizeText(raw);
  }
  const formatted = new Intl.NumberFormat(lang).format(numeric);
  const isSingle = numeric === 1;
  const label = lang === 'es-MX' ? (isSingle ? 'piso' : 'pisos') : isSingle ? 'floor' : 'floors';
  return `${formatted} ${label}`;
};

export const formatArea = (raw: string | number | undefined, lang: Lang) => {
  if (raw === null || raw === undefined) return '';
  if (typeof raw === 'number') {
    return `${new Intl.NumberFormat(lang).format(raw)} m\u00b2`;
  }
  const numberChunk = extractNumber(raw);
  if (!numberChunk) {
    return sanitizeText(raw);
  }
  return `${numberChunk} m\u00b2`;
};
